// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf /*, maybe */ } from "@altostra/type-validations";
import { number, any } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogFilteredSetsListDatatableResult = objectOf({
  hits: number,
  results: arrayOf(objectOf({ any })),
});
